/**
 * Alert scripts
 */

(function() {
  const siteAlert = document.getElementById('site-alert');
  const duration = siteAlert.dataset.duration;

  // Add a tracking class into each link in the alert
  if (siteAlert) {
	const links = siteAlert.querySelectorAll('a');

	links.forEach((link) => {
	  link.classList.add('site-alert-link');
	});

	// Lets also check if the alert is on the bottom
	const location = siteAlert.dataset.location;

	// If location is 'bottom' lets add a script to hide it when it is 200px from the bottom of the page
	if (location === 'bottom') {
	  window.addEventListener('scroll', () => {
		const scroll = window.scrollY;

		if ((window.innerHeight + scroll) >= (document.body.offsetHeight - 200)) {
			// Check the classlist to see if it is hidden
			if (!siteAlert.classList.contains('hidden')) {
				siteAlert.classList.add('hidden');
			}
		} else {
			if (siteAlert.classList.contains('hidden')) {
				siteAlert.classList.remove('hidden');
			}
		}
	  });
	}
  }

  if (duration) {
	  const delay = setTimeout(() => {
		siteAlert.classList.remove('hidden');
		console.log('Fire Alert');
	  }, duration);
  }
}());